export enum TripsCompleted {
    LESS_THAN_500 = 'Less than 500',
    FROM_500_TO_1000 = '500-1000',
    FROM_1000_TO_2000 = '1000-2000',
    FROM_2000_TO_3000 = '2000-3000',
    FROM_3000_TO_5000 = '3000-5000',
    FROM_5000_TO_7500 = '5000-7500',
    FROM_7500_TO_10000 = '7500-10000',
    MORE_THAN_10000 = 'More than 10000'
}

export enum UberTenure {
    ZERO_TO_SIX_MONTHS = '0-6 months',
    SIX_TO_TWELVE_MONTHS = '6-12 months',
    ONE_TO_TWO_YEARS = '1-2 years',
    TWO_TO_THREE_YEARS = '2-3 years',
    THREE_TO_FIVE_YEARS = '3-5 years',
    MORE_THAN_FIVE_YEARS = '5+ years',
    NEW = 'New to Uber'
}

export enum HoursDrivenPerWeek {
    LESS_THAN_10 = 'Less than 10',
    TEN_TO_TWENTY = '10-20',
    TWENTY_TO_THIRTY = '20-30',
    THIRTY_TO_FORTY = '30-40',
    MORE_THAN_40 = 'More than 40',
    NONE = 'None'
}
